
import * as React from "react"
import Table from 'react-bootstrap/Table';
import ExpandableText from "./expandableText";
import {NavigationBar, Layout} from "./layout"
import { Typography, Box, Stack } from "@mui/material";

const stories=[
{
  title: '潙仰宗領袖永化法師說"禪是我的初戀"',
  date: '2024-04-29',
  image: "master-3_orig.png",
  shortText: `永化法師分享他的經歷

BulkwangMedia 文章 2024年4月26日

領導美國溈仰宗的永化法師，目前正在韓國與當地佛教徒會面。我在盆唐的寶螺禪中心見到了法師，該中心位於書岦地鐵站附近的一棟商業大樓內。一進入這座寺院，我就感覺到法師們在這樣的環境中修行一定不容易。

永化法師來自越南，曾是美國一家大型企業的高管，但在遇到宣化上人後，便決心放下世俗生活。他專修禪宗，甚至說過：「我的初戀是禪」，但同時也弘揚淨土法門。他的師父——宣化上人所傳授的禪修和念佛法門，也逐漸在韓國廣為人知。

永化法師的言語直截了當，從不拐彎抹角，強調修行的實效性。無論是念佛還是禪修，他都強調應該解決現實生活中的問題。這種態度究竟是因為他曾經是商人，還是受美國務實主義影響？這個問題貫穿了整場訪談。
往生極樂世界

問： 您曾說：「若能至誠念佛，便能往生極樂世界。」這是真的嗎？
答： 這不只是我師父的話，也是中國禪宗大師永明延壽的教導。他最初修禪而開悟，但同時也提倡淨土法門。在中國，他被認為是阿彌陀佛的化身。他說：「任何人只要念佛，便能往生極樂世界。」我相信這些話，因為這是許多祖師大德的教導。

念佛確實可以讓人往生極樂，雖然不一定能在今世實現，但來世一定可以。

問： 您真的確信嗎？
答： 我相信。

問： 人們有時因為害怕死亡而信仰宗教。據說臨終時，阿彌陀佛會來接引我們。我們面對死亡時不會害怕嗎？
答： 要往生極樂世界並不容易，需要具備一定的條件。如果修到念佛三昧，阿彌陀佛在臨終時必定來接引，這就是進入淨土的門檻。若無法證得念佛三昧，那來世要往生就比較困難。

但阿彌陀佛不是曾發願說：「凡念我名號者，皆得往生極樂世界，將來成佛」嗎？即使沒有證得念佛三昧，只要念佛，來世仍然可以往生。事實上，能夠談論死後世界的人不多，而我的師父就是其中之一。
何謂「三昧」？

問： 什麼是三昧？
答： 三昧是佛教修行的重要元素，也是衡量弟子修行水平的重要標準。智慧的力量很重要，但定力也非常關鍵。三昧指的是專注的境界，一旦入定，就較不受外界干擾。例如，聲音、氣味等外在因素都無法影響修行者。

我的師父宣化上人的弟子中，有一位數學家，他修行達到很高的定力。他曾撰寫一篇數學論文，寫完後才發現自己已經持續工作了17個小時，卻沒有感到飢餓或口渴。

修行禪定時，靜坐不動，是為了進入無念的三昧境界。此外，生活中也可以修動中三昧，在日常行住坐臥間保持定力，這是非常重要的。
信心、利益與福報

問： 修行會增長信心，但也可能產生疑惑，例如：「這條路真的正確嗎？」您強調對善知識的信心，但您自己曾經懷疑過嗎？
答： 產生疑問是正常的。我當初遇到師父時，也有疑惑。但信心和疑惑都屬於個人經驗，不能依賴他人。

首先，你要考慮「這個老師值得信任嗎？他所說的話可信嗎？」其次，你要看「他的教導是否能與自己內心契合？」最後，還要看有沒有「感應」。

例如，我師父曾對我說：「不要為自己辯解。」如果你的摯友誤解了你，你會想辯解。但師父告訴我：「不要辯解。」當時我無法理解，直到十年後才體悟其中的道理。這就是「感應」。

「感應」的意思是，當你真正去實踐教法時，會有實際的受益。這就是智慧的教導。有人可能會對教義說得天花亂墜，但真正重要的是，它是否對自己有幫助。

這也是中國佛教的傳統。如果想學習禪宗或淨土法門，首先要找到善知識。佛教要興盛，就需要感應和傳承。

問： 修行有很多好處，除了開悟，還包括健康與福報，甚至是現世的實際利益？
答： 起初我並不想談論這些世間利益。畢竟，禪修是高尚的，不能以功利角度來看，對吧？但我不間斷地講法已經18年了，弟子們聽久了也會覺得無聊（笑）。

其實，我並不是在談論世俗利益，而是關心人們的問題，幫助他們找到解決方案。有些人來是因為抑鬱，有些是因為健康問題，還有些是因為生活困境。問題是：「禪修能幫助我解決這些問題嗎？」答案是：可以！禪修在日常生活中能發揮實際作用，幫助人們改善生活。

我們可以談論禪宗的原理和深奧教義，但如果它無法解決人們的日常困擾，又有多少人會真正對禪感興趣呢？
韓國佛教的印象

問： 您多次來韓國，對韓國佛教有什麼印象？
答： 我來過幾次，五年前初次到訪時，老實說沒有什麼特別的印象，感覺像是來度假。但後來有人請我開設道場，我便派了一位弟子——賢安法師來韓國，於是我有機會在這裡弘法。

幾次來訪後，我對韓國佛教有了更深的認識。韓國佛教穩定而強大，儘管中國不一定承認，但我認為韓國佛教是亞洲佛教的重要支柱之一。我也見到了許多高僧大德，了解到韓國佛教的師承傳統。

但我更關心的是，韓國佛教的弟子們非常有才華。既然人才眾多，為什麼只培養一兩個人？跟隨我們修行的韓國弟子，有很多達到了很高的境界。他們確實很有天分。

問： 在寶螺禪中心，有很多年輕人參與修行。
答： 現在的宗教普遍吸引不到年輕人，韓國佛教也面臨這個問題。雖然韓國佛教很強大，但它需要改變。許多年輕人因為經濟壓力，無法參與寺院事務，容易被排除在外。但這沒關係，因為我們出家人本來就很窮（笑）。

這裡不僅有年輕人，甚至還有許多天主教徒。我認為我們可以在這方面幫助韓國佛教。

訪談結束幾天後，永化法師返回美國。`,
  fullText: null
},
{
 title: "走出自己的路，你會得到屬於你的禪“禮物”",
 date: "2023-03-01",
 image: "screen-shot-2023-03-04-at-6-38-10-pm_orig.png",
 shortText: `我天生左側髖關節脫位，所以當我開始打坐時，甚至半蓮花坐對我來說也非常困難。我的禪師，XX法師，非常小心，沒有強迫我過度勉強自己。她唯一要求的就是每天坐得多一點。

於是，我照做了。從半蓮花開始，我努力分散注意力，讓自己不去鬆開雙腿。我嘗試過看YouTube、聽音樂、跟朋友聊天……無論是什麼，我都嘗試過。就這樣，我慢慢地把我的半蓮花坐時間從十分鐘增加到將近一小時，每天多加半分鐘到一分鐘。

我開始打坐是因為我在醫院工作，壓力非常大。自從疫情以來，壓力只增不減。我嘗試過引導冥想，但在短時間內便無法再進展。直到有一位信任的朋友告訴我禪，我決定試試看。痛苦是出乎意料的。但如果我要從中獲得任何東西，我就必須全力以赴。

剛開始，我無法理解師父的講話。是的，他很有趣，但我根本不知道他在講什麼。這之前我對佛教一無所知。直到有一天，痛苦讓我徹底迷失，所有以前有幫助的方法都無效。在絕望中，我找到了一個師父的視頻，突然之間，我明白了！我聽懂了他說的每一句話。他說：“忍受痛苦能積累福報”，“要進步，必須不放棄！”

就這樣，因為不放棄，我進步了。經過短短幾個月，我就能坐上全蓮花了。練習禪佛教一年半後，我的新紀錄是四個小時！

還痛嗎？哦，當然痛。痛得像地獄一樣。然而，在極度的痛苦之後，我體驗到了極大的快樂。當我覺得自己快到極限，無法繼續下去時，砰！鐘擺向相反的方向擺動。而且我的精力、專注力、情緒和恢復時間達到了我一生中的最佳狀態。

但不要只聽我說，自己試試看！走出自己的路，你會得到屬於你的禪“禮物”。

    F.L.`,
 fullText: null
},
{ title: "艾蜜莉(賢嚴法師)的修行故事",
 date: "2023-02-01",
 image: null,
 shortText: `「我原本計畫去加州拜訪朋友，但也帶著一個任務，那就是參觀一座佛寺。我在內心發出了一個訊息，請求幫助尋找一個真實的寺廟，一個有真正師父可以教導和指引我的地方。我在Yelp App上進行搜尋，第一個顯示的是廬山寺。我對這個名字有著深深的連結，於是我心想，“好吧，就去那裡。”當我到達時，我告訴一位法師我是通過Yelp找到這裡的。她告訴我，這是緣分把我帶到這裡的，因為他們並沒有在Yelp上做廣告。

在那裡，我分享了一個我在朋友宴會上的經歷。那是一個盛大的慶祝活動，大家吃喝歡樂。我的哥哥遞給我一大盤牛排。直到那時，我一直很喜歡吃肉。突然，我看到一隻黑色的牛的臉在對我哭泣並哞哞叫。我呆住了，心裡痛得無法言喻，喉嚨裡有一塊石頭。我的哥哥一直在叫我，好像從遠處傳來。我從幻象中回過神來，搖搖頭，說我不想吃了。法師告訴我，那是慈悲咒語對低等生命（動物和昆蟲）的顯現。我從寺廟的一位在家弟子那裡得知，要成為一名佛教徒，我必須要皈依。

我一直以為自己就是佛教徒。我的父母和親戚不是佛教徒嗎？畢竟，每逢農曆的初一和十五，我們都會燒香祭拜佛菩薩；每年農曆新年，我們會做祭品，像是“紙錢”，擺放水果，甚至是熟肉！（其實這是道教的信仰，我後來才知道。）

廬山寺把我帶入了禪宗的教導，教我們如何打坐入蓮花坐。當我還是小孩的時候，我輕鬆地就能坐上蓮花坐，這對我來說既簡單又有趣！當一位法師要求我們這些初學者坐蓮花坐時，我仍然能做得到。但是，它絕對不像我小時候那麼輕鬆舒適。（這裡有個小秘密。當我小時候，我告訴父母我想當和尚，並請他們把我送到中國的少林寺。當我爸爸告訴我不允許女孩進去時，我傷心得不得了。）法師教我們按照禪的方式打坐，要忍受痛苦，目標是一小時，一天一點點地增加，每天增加五分鐘。

回到芝加哥後，我繼續坐全蓮花，並念誦我學到的咒語。起初，我只能坐10到15分鐘就要鬆開雙腿。但憑著堅持，我將時間延長到30分鐘、45分鐘，最終達到一小時。我在懺悔中繼續打坐，時間一長，我的坐禪時間也成倍增加，每當有機會參加佛七和禪七，我都不會錯過。每當我痛苦加劇，痛苦的程度也愈加艱難。

我的工作壓力很大，時常面對最後期限的臨時要求和不斷的打斷。每天，我要處理各種各樣的人物，解決許多麻煩、情緒起伏的問題。我的耐心和困擾不斷受到考驗。

在將近七年的佛教弟子禪修中，我注意到自己生活的巨大變化，和過去相比，如今的我無論如何都能保持清醒。每當我感到快要感冒時，我只要打坐就能化解。小感冒幾乎是立刻消失，當我專注於丹田時，強烈的病毒感冒需要更長時間，最多三小時。Omicron也讓我花了更長的時間，但最終，我學會了擊退更強的變異病毒。即便是最難纏的病毒，打坐繼續讓我保持健康安全。

這是練習禪佛教的一些其他好處：

    我學會了更加容易放下事情。隨著時間的推移，這變得越來越容易。
    我感到內心平靜，沒有理由的滿足感。
    即使在最具壓力的情況下，我也能更好地運作，感覺自己變得更加敏銳。
    我變得更加有耐心，這一直是我需要克服的最大障礙。
    我通過自己的經歷，學會了在最需要的時候真誠地向佛菩薩請求幫助。

最後，我只能希望你們也能獲得與我在修行過程中一樣的禮物。我希望你能抓住機會，開始屬於自己的修行。這些好處是無限的。」`,
 fullText: null
},
{ title: "韋陀菩薩",
 date: "2023-01-10",
 image: "weitou_orig.png",
 shortText: `「我想分享一個關於韋陀菩薩的故事和經歷。

很久以前的一天，我坐在地板上讀《四十二章經》，這本經書是永華法師解釋的。當時，我的背開始感到疼痛，所以我躺下來休息了幾分鐘。我拿起書本放在眼睛上，過了幾分鐘後，我漸漸入睡了。

接著，我做了一個奇怪且可怕的夢。我看到一位穿著古代服裝的男子，手中拿著一根杵。他對我非常憤怒，開始追趕我。他的臉色嚴肅且兇狠。指著用來遮住我眼睛的書本，他責備我說：“你怎麼敢這樣對待經書？”

我被他的憤怒驚醒，立刻坐了起來。書本從我的臉上滑落，打開了，露出韋陀菩薩的形象。這個形象與我在夢中看到的完全一致：他的面容、衣服、手中的杵，一切都一模一樣。那時，我毫不懷疑，甚至至今，我相信我曾經被韋陀菩薩造訪過。我發誓再也不會對任何神聖的物品不敬。」`,
 fullText: null
},
{
title: "修行者的日記：李善美",
 date: "2024-04-29",
image: "1874117349_orig.jpg",
shortText: `修行者的日記：李善美 11月30日，聆聽達摩開示後：

這是佛七修行的最後一堂法會。當師父說："請分享你們的佛七體驗"時，許多人表達了感謝。有人說這只是一段痛苦的經歷，但有一位來自韓國的修行者說，她在四月份接受了師父的作業，要坐禪三個半小時。她來參加佛七是為了請教下一步該做什麼。哇，三個半小時。我也想努力修行，習慣坐禪三個半小時。我要見到師父並能舒適地坐禪三個半小時的誓願變得更加堅定。有一天，我想乘飛機去美國見師父，這樣我就能請教下一步該做什麼。

12月1日
結跏趺坐：1小時57分鐘
觀呼吸：1小時
楞嚴神咒念誦：30分鐘
阿彌陀佛念佛：12分鐘
楞嚴神咒讀誦：10分鐘

今天我想比昨天做得更好，所以我設置了1小時50分鐘的鬧鐘。（昨天我大約下午3點吃完飯，之後只喝了兩杯茶）。坐了1小時25分鐘後，我的腿開始顫抖。

我的肩膀開始感到酸痛。我把手掌合十，手掌和肩膀開始微微顫抖。如果我拿著薩滿的鈴鐺，鈴鐺一定會劇烈搖晃並發出聲音。我感到有點害怕。

賢安法師已經告訴我不必害怕，應該讓顫抖自然發生。宣化上人說顫抖有助於擺脫愚癡。當我提醒自己賢安法師的話時，我繼續專注於楞嚴神咒念誦。大約5分鐘後，我手臂的顫抖自然平靜下來。不久之後，我的手和頭也平靜下來。

隨著時間的推移，之前一直困擾我的右腳和髖部疼痛消失了，但左腳非常疼痛。因為從昨天開始禁食並下定決心要坐得更久，我能夠忍受這種疼痛更長時間。由於我的左腳從小就有很多問題，當疼痛開始時，這是預料之中的。疼痛在增加，但我的頭腦越來越清晰，雜念也減少了。我感覺如果能夠忍受左腳的疼痛，我可以坐得更久。我比原計劃多坐了7分鐘才結束。

今天我想起了我的父母。我為他們祈禱，希望他們在餘生中能夠積累更多的福報，因為他們一直在為生存而奮鬥。南無阿彌陀佛觀世音菩薩`,
fullText: null
},
{
title: "李思自2016年開始習禦禪修的經歷：如何改變了她的生活和周圍的人（克服憂鬱症）",
 date: "2019-12-14",
image: "dsc02677_orig.jpg",
shortText: `我叫李思貝絲，今年38歲，是雅基族的原住民美國人。我的母親出生於薩克拉門托，她是雅基族和挪威混血；而我的父親是出生在墨西哥的美國公民，他的祖先是西班牙人和惠卻爾族（一個原住民部落）。我父母在我童年時期就分開了。我有一個16歲的兒子名叫塔科達，他也修習禪坐。

起初，我試圖克服的困難是憂鬱症。那時我正經歷一場離婚。我母親患有躁鬱症，我的小妹妹身有殘疾，她總是試圖與我們所有人爭吵，而我需要照顧她們兩人。我的兒子是個善良且懂事的人，但即便如此，他也受到了家中所有事情的影響，他的學校成績下滑了。他的老師們讚揚他有良好的禮貌，只是希望他能更用心於學業。我在控制自己的思緒和情緒反應方面有很大困難。獨自一人在車裡時我會哭泣。我不喜歡自己的脾氣暴躁，有時我會失眠，或者睡得太多，經常打瞌睡並感到疲憊。我還有膝蓋受傷和下背痛問題。總的來說，我對自己的生活感到不滿意。

我在2016年開始習禦禪修。當時我正和兒子在公園散步，看到有人張貼「公園禪修」的告示。我詢問她教課要收多少錢。她說：「免費的。」一切就這樣開始了！

剛開始，當我開始結跏趺坐並默念阿彌陀佛時，我感受到了身體上的癒合。我的膝蓋很快就康復了，下背部也不那麼痛了。幾個月後，我每天能靜坐一小時，並感到精神煥發。不久，我的失眠消失了，我能夠整夜安睡。我也不需要那麼多睡眠就能感到精力充沛。漸漸地，我開始注意到我的思緒更加專注，不再憤怒或憂鬱，能夠清晰地思考。我不再對他人的行為做出急躁的反應。我對每個人包括自己都更有耐心和包容。我的小妹妹在我身邊變得更加平靜，很容易就能安撫下來。她不再試圖與我爭吵。我母親的躁鬱症也沒有以前那麼嚴重，她更願意接受我關於她健康的建議。甚至連我兒子的學業成績也有所提高。我更支持他，他也開始修習禪坐。

我的靈性源自美洲原住民傳統。這不是一種宗教，而是一種生活方式。它對其他人的信仰非常包容。我認為過去的許多靈性領袖都是為教導我們某些事物而生的聖人，我們可以選擇接受這些教導並運用它們，也可以選擇不接受。我選擇將禪修作為自我照顧的一部分，這實際上幫助我改善了照顧他人的方式。

禪修在很多層面上幫助我進步，但如果要選擇一件它幫助我最多的事情，那就是我的心智和組織思緒的能力。我不再對自己的選擇和決定感到茫然。我報名上了大學，並被榮譽計劃錄取。我不再擔心要達到別人對我的期望。我清楚地看到自己在擔心那些很可能永遠不會發生的事情上浪費了多少時間。現在我比以前更深刻地享受生命中的珍貴時刻。`,
fullText: null
},
{
title: "胡安的禪修經歷：生命的轉變！",
 date: "2019-12-14",
image: "20190915-160105_orig.jpg",
shortText: `
潙山寺賢安法師撰寫

我記得大約兩年前第一次在廬山寺見到胡安時的情景。那時我非常忙碌，沒能與他多談，但我記得他總是在寺院裡工作，即使在午餐時間當其他人都在享用食物時也是如此。有一天我問他：「為什麼不來和大家一起用午餐？」他說：「我不想消耗我的福報。我想工作並幫助寺院。」

與我不同，胡安總是在寺院裡勤奮工作，然後靜靜地回家。他規律地這樣做，大概每週一次或兩次。他禮貌地拒絕用午餐，繼續工作。

今天我看到他在永化法師的經文講座期間結跏趺坐。整整兩個小時，他沒有動也沒有發出任何聲音，臉上流露出平靜的表情。我想了解修行如何改變了他的生活，所以我邀請他進行交談。

胡安於1981年出生在墨西哥瓜達拉哈拉，他的家人在他只有8歲時移居美國。他是一名職業護士，已結婚11年，沒有孩子。他在一個典型的墨西哥家庭中長大，去天主教堂做禮拜。直到17歲，他每個週末都和家人一起去教堂。

然而，在二十多歲時，他過著自我毀滅的生活。他留著像搖滾樂手那樣的長髮，身上有大型紋身，經常喝酒抽煙。他把時間花在與朋友一起參加音樂會上。像許多美國年輕人一樣，他也嘗試各種藥物。

他的生活沒有方向，但不想回到天主教堂。他覺得教堂沒有為他的問題提供任何切實可行的解決方案。他也不同意講道中的某些部分。因此，他決定嘗試佛教寺院。

他做了一些網上研究，找到了一座日本佛教教堂。他每週去這個教堂一年之久，但他的生活中沒有經歷任何實際或切實的變化。那裡沒有真正的僧侶或禪修課程。教堂成員沒有遵守戒律。他們吃肉，抽煙和喝酒。他決定不再去了，因為他想找一個更有原則的地方修行。大約一年後，他了解到廬山寺，看到一些照片，並喜歡他所看到的。
胡安第一次訪問廬山寺時，他很緊張。當時正在舉行禪七。他看到人們在佛堂中結跏趺坐，所以他也自然而然地結跏趺坐。他經歷了劇烈的疼痛，但那天能夠坐約30分鐘。當他得知永化法師每天晚上都會進行法談時，他決定留下來聽講。他與永化法師的佛法感到強烈的連結，當法師說我們都可以成佛，不管我們是誰或來自哪裡，這給他留下了深刻的印象。

他決定在廬山寺幫忙，以創造更多福報，正如他在法談中所學到的。他希望這些福報能幫助他超越世俗生活。

從那時起，胡安每天都在禪修，三個月內，他能夠坐超過一小時。由於每日禪修，他的生活發生了巨大變化。他自然而然地停止了飲酒，心中升起的憤怒也明顯減少。僅僅幾個月的禪修和在寺院做義工就為他帶來了內心的平靜！他成為了更好的兒子和兄弟。

六個月內，他正式成為佛教徒，在永化法師座下皈依，並受持五戒。此後，他的生活變化更大。最大的變化之一是他開始認真修行。胡安開始每天至少結跏趺坐兩小時。他對周圍環境和人更加覺察。他成為了一名更好的護士，在聆聽病人時更有耐心，幫助他們更舒適和快樂。他的生活變得更有意義...但也有一個缺點。自從他真誠地、以更開放的心關心病人後，他的健康開始下降。作為護士，他一直在干預——干涉他所治療的病人的業債。

他向賢傑法師尋求建議，並被告知藥師法門。胡安了解到，通過創造更多的藥師福報，他可以改善自己的健康、職業和修行，所以他請求立藥師牌位。令人驚訝的是，他不再那麼容易感到生病，而且他的身體健康立即顯著改善。他還注意到，在工作中他的心理更加穩定。

胡安甚至想過出家。他非常感謝賢傑法師對他修行的幫助。胡安只是我們寺院社區非常國際化、文化多元融合的又一個例子。我希望他在不久的將來能在修行中取得成果。`,
fullText: null
},
{
title: "矽谷科學家阿拉溫在潙山寺佛七的體驗",
 date: "2019-12-14",
image: "2019_orig.jpg",
shortText: `
阿拉溫來到潙山寺，停留一週參加佛七念佛法會。「佛七」字面意思是「七天念佛」，這是一種#淨土法門，全天持誦#阿彌陀佛聖號。佛七的日程非常嚴格。每天從凌晨4點開始，參與者全天參加法會和念佛，直到晚上10點結束。

阿拉溫的分享

我叫阿拉溫·納塔拉揚（男，41歲）。我在舊金山的健康科技公司#Fitbit擔任數據科學家。我在印度長大，來美國攻讀物理學博士學位，後來成為研究科學家。之後我對數據科學、機器學習和人工智能產生了興趣，因此來到灣區。

我對佛教產生興趣是因為我發現佛教祈禱很平和，我喜歡非暴力和對所有生命慈悲的理念。2014年，我在拉達克（拉達克位於印度，但非常接近西藏）的一座佛教寺院短暫做過英語教師志願者，這次活動由#觀音信託組織，這是我第一次體驗佛教環境。後來我去日本進行研究旅行，有機會參觀鎌倉，包括長谷觀音寺和著名的阿彌陀大佛像。在離家更近的尤凱亞，我們有一個廣闊美麗的萬佛城，那裡有孔雀和鹿。我發現我喜歡萬佛城的誦經，並在有機會時加入其中。我也喜歡參加伯克利寺院的週六早晨法會。

當我差不多兩年前開始在Fitbit工作時，公司有正念課程，我每週都參加。那些課程很愉快，但我覺得冥想還有更多內涵，因此開始尋找適合初學者的好書。這就是我如何找到師父的禪修書籍，這對初學者來說是一個極好的資源。我感到很幸運能在舊金山的一個#聚會活動中遇見師父和他的在家弟子及出家弟子，師父在那裡進一步講解了禪修及其改善我們身心健康的能力，以及如何使我們成為更好的人。

今年在伯克利寺院舉辦的衛塞節（#釋迦牟尼佛誕辰）期間，我參加了為期三天的#阿彌陀佛念佛法會。去年感恩節期間，我也參加了伯克利#寺院的三天阿彌陀佛念佛法會。萬佛城每年舉辦三次觀音聖號誦持法會，我參加了這些週日和週六的活動。潙山寺的#佛七是我第一次參加七天的法會，也是我第一次在法會期間住在寺院。

第一天結束時，我非常疲倦，甚至得拖著自己下樓去刷牙——我當時在想我到底報名參加了什麼，以及我如何能完成這一週！幾天後我習慣了這個日程。有趣的是，隨著一週的進行，我發現變得越來越容易。到最後，我發現自己擁有比平常多得多的能量，儘管我吃得更少，睡得也少得多！#誦經和禪修環節幫助我們達到一種平和的心境。我從這次法會中獲益良多，鼓勵大家都來嘗試。

在Fitbit，我參與了一個項目，研究心率、呼吸和皮膚電導在#正念體驗期間如何變化。這是我冥想時連接到測量這些不同生物信號的機器的照片。`,
fullText: null
},
{ title: "身心轉變：比利·蒂特的經歷",
 date: "2019-11-11",
 image: "image_orig.jpg",
 shortText: `比利·蒂特是廬山寺和衛山寺的常駐義工。他從兩年前開始經常來廟裡。他是一位重度吸煙者，並且是自己的老闆，沒有人能告訴他該怎麼做。他經常把自己的老闆解雇，並且很自豪地為此感到驕傲。然而，由於脾氣不好，他的生活並不輕鬆。

他是一位單親爸爸。自從和妻子分開後，他的女兒選擇與他同住。他總是擔心如何養活年幼的女兒。由於他無法長時間穩定工作，他經常需要為了找工作和支付賬單而努力。

他的健康也很差。他吸煙過量，食慾不振，體重很輕，並且有背痛的問題。他還有心臟問題，總是感到疲倦，對工作缺乏動力。

他曾經很多年前來過廬山寺，當時他的生活陷入困境，健康狀況也在惡化，於是他想起了寺廟，並決定兩年前再次來到廟裡。剛開始來廟裡的時候，他並沒有特別努力坐全蓮花。他只是聽法師的法談，並在廚房周圍幫忙洗碗、打掃等。

比利開始坐禪，每次大約只坐10到20分鐘，並聽法師的法談。這對他幫助很大，他變得不再那麼焦慮，身體也隨著常來寺廟變得好多了。他繼續幫忙，並開始參與衛山寺的更多活動。

有一天，他在午餐時間進入佛堂，像往常一樣，他三次向佛祖頂禮。一位尼姑對他大聲喊道：“你回來坐下！”這讓他感到意外。他沒來得及反應或拒絕，就聽到她說：“哦，好吧…我先去向宣化大師的聖像頂禮一下，然後再回來。”

他回到了佛堂，坐下來開始打坐。那位尼姑問他：“你能坐多久？你坐全蓮花的最長時間是多少？”比利回答說：“大概10分鐘…也許15分鐘。”

那位尼姑堅定地說：“好，從現在開始，你不可以解開，聽到了嗎？我去做午餐供養，然後回來。你不能解開，直到我告訴你可以。”比利回答：“好。”

尼姑完成了供養後，坐在他旁邊。比利已經坐了約20分鐘，他開始抱怨疼痛：“我出汗了，我再也坐不下去了，感覺心臟有東西在戳我！”尼姑說：“是嗎？這是正常的，繼續坐，別解開。”

又過了10分鐘，比利說：“我的手臂麻了，動不了了，背很痛。”尼姑說：“哦，這是正常的，繼續坐，直到我告訴你可以解開。”

他確實很痛苦，但那位尼姑一直不轉頭看他，專心盯著他。尼姑告訴他：“你愛你的女兒嗎？你今年多大了？”“我48歲。”“你的女兒還小，你不想一直保持健康直到她長大嗎？”比利回答：“當然想。”“那你必須坐下來，你必須學會變得更好。你之所以痛，是因為你的身體有病。”

尼姑繼續說：“現在已經是午餐時間了，你知道我不吃晚餐，所以我現在非常餓，應該感謝我決定留下來看著你。我還在幫助你，所以你最好不要解開。你快完成了，只需要忍耐！”

當比利坐了一個小時後，突然他的臉色變得更加明亮，整個人看起來更冷靜了。尼姑說：“好了，現在你可以解開了。記得慢慢來，確保你的腿恢復正常再下樓，別摔倒。”

比利在坐禪後變成了不同的人。第二天，比利回到寺廟告訴我們：“我感覺不一樣了，我的身體更強壯了。雖然腿還很酸痛，但我精力充沛了。工作也不再那麼累，我對工作更有動力了，第二天還能繼續努力。”

比利說，自從那次坐了一個小時後，他每天都感覺更有精力，即使晚上睡得少，第二天也不再感到疲倦或困倦。他變得更加快樂，情緒也更穩定。他總覺得自己的問題來自他人，而不是自己。但自從那次經歷了如此劇烈的痛苦後，他不再那麼在意別人給他帶來的問題。他的脾氣變得更好，感覺也更加輕鬆。

比利第二天回到佛堂，坐了超過一個小時十五分鐘。他的女兒說，她為她的爸爸感到驕傲！`,
 fullText: null
},
{ title: "來自韓國修行者的信息",
 date: "2019-11-11",
 image: "kakaotalk-photo-2019-11-16-06-07-40.jpeg",
 shortText: `—— 由現安法師所寫

2019年初，我們在韓國拜訪了奉恩寺，並遇到了石豆師父。奉恩寺是首爾市最大的寺廟之一。禪修結束後，我（當時是山娜）再次拜訪了奉恩寺，幫忙翻譯他們的寺廟介紹手冊。

石豆師父介紹了一位非常努力修行的在家女信徒給我認識。我們一起鼓勵她學習如何坐全蓮花。之後，她通過Messenger與我聯繫，並開始每天練習坐全蓮花。

她自責無法在冥想時集中精力。她曾經受到一位韓國大師的指導，讓她修習話頭，但她遇到了很大的困難。我解釋給她聽，無法集中注意力是正常的，因為她還沒有打好基礎。

練習非常困難，因為她忍受著極大的疼痛。即便她已經坐了超過一個半小時的全蓮花，她還是未能突破那個痛苦的障礙，但她從未放棄。她堅持練習，並按照指示繼續努力，忍耐著忍耐著。

昨晚，她給我發了訊息，告訴我她終於能坐兩個小時了。她說：“疼痛太強烈了，無法忍受，但在這極度的痛苦中，我的心智卻變得更加清晰。”她在奉恩寺禪修中心修行，但那裡的坐禪時間只有50分鐘。我鼓勵她繼續超越正常的休息時間坐下去，結果她帶著眼淚和汗水成功地完成了。

她能感覺到自己的專注力有所提高，心境比以前更加清晰。我明白，這樣的進步在沒有我們現場支持的情況下並不容易。她很堅強，決心修行！`
 ,fullText: null
}


]
function CultivationStories() {

  return (
    <><NavigationBar/>
      {/* Hero Image */}
<div style={{ display: "grid" }}>
      <img
        style={{
          gridArea: "1/1",
          // maxHeight: 600,
        }}
        layout="fullWidth"
        aspectRatio={3 / 1}
        alt=""
        src="/eventBanner.png"
        />
      <div
        style={{
          gridArea: "1/1",
          position: "relative",
          placeItems: "center",
          display: "grid",
        }}
      >
      </div>
    </div>
    {/* Main Content */}
  <Layout>
<Table><tbody><tr><td>
{stories.map((story, index) => (
  <div key={index} className="bg-white shadow-lg rounded-lg overflow-hidden">
    <div className="p-4">
      <Typography variant="h3">{story.title}</Typography>
      <Typography variant="body1">{new Date(story.date).toLocaleDateString()}</Typography>
      <hr/>
      {(story.image == null)? <></> : <><img src={story.image} alt={story.title} className="w-full h-48 object-cover" /><br/></>}

      <ExpandableText shortText={story.shortText} fullText={story.fullText} />
    </div>
  </div>
))}
</td><td></td></tr></tbody></Table><br/>
  </Layout></>
  );
}

export default CultivationStories;
